export default class LoopsLockManager {
  constructor(role) {
    this.role = role;
  }

  isLocked(node) {
    if (this.role === 'teacher') {
      return false;
    } else {
      return node.data('metaLockedBy') || node.data('lock_state') == 'locked';
    }
  }

  isPasswordLocked(node) {
    if (this.role === 'teacher') {
      return false;
    } else {
      return node.data('lock_state') == 'code';
    }
  }

  hiddenMarker() {
    if (this.role === 'teacher') {
      return 'teacherHidden';
    } else {
      return 'hidden';
    }
  }
}
